<template>
  <v-jsf
      :value="modelJson"
      :schema="schema"
      :options="options"
      @input-child="inputChild"
      @input="inputCaly"
      @change="change"

  >
    <template slot="custom-table" slot-scope="context">
      <v-jsf-table v-bind="context"/>
    </template>
    <template slot="custom-table-tcn" slot-scope="context">
      <tcn-table-lite v-bind="context" @input="updateModel"/>
    </template>
    <template slot="custom-stepper-tcn" slot-scope="context">
      <tcn-form-stepper v-bind="context"/>
    </template>
    <template slot="custom-dynamic-input" slot-scope="context">
      <VJsfDynamicHttpInput
          v-bind="context"
          :model="localModel"
          @updateCode="updateModelByKeyValueObject"
      />
    </template>
    <template slot="custom-tcn-lazy-combo" slot-scope="context">
      <TcnLazyCombobox
          v-bind="context"
          @input="updateModelByKeyValueObject"
          :model-root="localModel"
      />
    </template>
    <template slot="custom-tcn-pozycja-faktury" slot-scope="context">
      <TcnPozycjaFaktury
          v-bind="context"
          @updateArrElement="updateArrElement"
      />
    </template>
    <template slot="custom-tcn-text-field" slot-scope="context">
      <TcnTextField
          v-bind="context"
      />
    </template>
    <template slot="custom-tcn-form-typo" slot-scope="context">
      <TcnFormTypography
          v-bind="context"
      />
    </template>
    <template slot="custom-tcn-btn" slot-scope="context">
      <TcnBtn
          v-bind="context"
          :model-root="localModel"
          @resolveAction="resolveAction"
      />
    </template>
    <template slot="custom-tcn-file-dropzone" slot-scope="context">
      <TcnFileDropzone
          v-bind="context"
          @input="updateModelByKeyValueObject"
      />
    </template>
    <template slot="custom-tcn-file-input" slot-scope="context">
      <TcnFileInput
          v-bind="context"
          @input="updateModelByKeyValueObject"
      />
    </template>
    <template slot="custom-tcn-header" slot-scope="context">
      <TcnHeader
          v-bind="context"
      />
    </template>
    <template slot="custom-tcn-section" slot-scope="context">
      <TcnSection
          v-bind="context"
          :root-model="localModel"
          @input="updateModelByKeyValueObject"
      />
    </template>
    <template slot="custom-tcn-text-area" slot-scope="context">
      <TcnTextArea
          v-bind="context"
          @input="updateModelByKeyValueObject"
          :model="localModel"
      />
    </template>
    <template slot="custom-tcn-map" slot-scope="context">
      <TcnMap
          v-bind="context"
      />
    </template>
    <template slot="custom-tcn-transform-text-field" slot-scope="context">
      <TcnTransformTextField
          v-bind="context"
          @input="updateModelByKeyValueObject"
      />
    </template>
  </v-jsf>
</template>

<script>
import VJsf from '@koumoul/vjsf/lib/VJsf.js';
import '@koumoul/vjsf/lib/VJsf.css';
import '@koumoul/vjsf/lib/deps/third-party.js';

import VJsfTable from './v-jsf-table.vue';
import TcnTableLite from './TcnTableLite.vue';
import TcnFormStepper from './TcnFormStepper';
import VJsfDynamicHttpInput from './VJsfDynamicHttpInput';
import TcnLazyCombobox from "./TcnLazyCombobox/TcnLazyCombobox";
import TcnPozycjaFaktury from "./TcnPozycjaFaktury";
import TcnTextField from "./TcnTextField";
import TcnFormTypography from "./TcnFormTypography";
import TcnBtn from "./TcnBtn";
import TcnFileDropzone from "./TcnFileDropzone";
import TcnFileInput from "./TcnFileInput";
import TcnHeader from "./TcnHeader";
import TcnSection from "./TcnSection";
import TcnTextArea from "./TcnTextArea";
import TcnMap from "./TcnMap";
import TcnTransformTextField from "./TcnTransformTextField";
import {mapActions, mapGetters} from "vuex";

export default {
  name: "TcnVJsfWrapper",
  components: {
    TcnTransformTextField,
    TcnTextArea,
    TcnSection,
    TcnHeader,
    TcnFileInput,
    TcnFileDropzone,
    TcnBtn,
    TcnFormTypography,
    TcnTextField,
    TcnPozycjaFaktury,
    TcnFormStepper,
    VJsf,
    VJsfTable,
    TcnTableLite,
    VJsfDynamicHttpInput,
    TcnLazyCombobox,
    TcnMap
  },
  model: {
    prop: 'modelJson',
    event: 'input'
  },
  props: {
    sectionKey: {type: String, default: null},
    /** JSON schema. Form structure. */
    schema: {},
    /** Form data */
    modelJson: {},
    /** See more: https://koumoul-dev.github.io/vuetify-jsonschema-form/latest/configuration */
    options: {}
  },
  data() {
    return {}
  },
  computed: {
    localModel: {
      get() {
        if (this.sectionKey !== null) {
          return this.modelJson[this.sectionKey]
        } else {
          return this.modelJson;
        }

      },
      set(val) {
        // console.log("Emituje z wrappera")
        // this.$emit('input-child', val);
      },
    }
  },
  watch: {},
  methods: {
    ...mapActions(["updateByKey","setRootModel"]),

    updateArrElement(obj) {
      console.log(`Aktualizuj wiersz ${obj.value.index}`, obj)
      if (obj.value.item === undefined) {
        // delete from model
        this.localModel[obj.key] = this.localModel[obj.key].filter((item, i) => i !== obj.value.index)
      } else {
        this.$set(this.localModel[obj.key], obj.value.index, obj.value.item)
      }
    },
    resolveAction(action) {
      console.log("Emituje VjsfWrapper", action)
      this.$emit('resolveAction', action)
    },
    showError(err) {
      console.error(err);
      this.$emit('showError', err);
    },
    showChange(e) {
      console.log('"change" event', e);
      this.$emit('modelUpdated', this.localModel);
    },
    showInput() {
      //   console.log('"input" event', e);
      this.$emit('modelUpdated', this.localModel);
    },
    updateModelByKeyValueObject(obj) {
      if (obj !== null && "key" in obj) { //TODO przy usunieciu z lazyCombo wartosci dziwny emit wartosci jeden okej + null
        console.log("Aktualizacja", obj)
        this.$set(this.localModel, obj.key, obj.value)
        console.log("LoclaModel ulega zmianie", this.localModel)
      }
    },
    updateModel(val) {
      this.localModel.tabela1 = val;
    },

    inputChild(val) {
      console.log("input-child", val)
      if (val.fullKey !== 'root') {
        this.updateByKey(val)
      }
    },
    inputCaly(val) {
      console.log("input", val)
      //this.localModel = val
      //this.setRootModel(val)
      // for (const key in val) {
      // //this.modelJson[key] = val[key]
      //   if (key in this.modelJson) {
      //     this.modelJson[key] = val[key]
      //   } else {
      //     this.$set(this.modelJson, key, val[key])
      //   }
      // }
      // // this.$emit('input', val)
    },
    change(val) {
      console.log("change", val)
    }
  },
  mounted() {
  }
}
</script>

<style scoped lang="css">

</style>
